module.exports = __webpack_public_path__ + "static/media/icon1.79bcd77b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon1.jpg
// module id = 129
// module chunks = 0